export default __webpack_public_path__ + "static/media/container@2x.3450c1b8.png";